module.exports = __webpack_public_path__ + "610f324f0e4eea1e922024fc960ba206.png";